import * as React from "react";
import { GraphDetails } from "../copiedGraphDetails";
import { GraphDetailSelection } from "../../util/graphDetialsSelectionHook";
import { Button, styled } from "@mui/material";
import { SupportFocusMutation } from "../responsiveGridLayout";
import { GraphSelectionSummary } from "../graphSelectionSummary";
import { ScrollableContainer } from "fe-common/ui/commonStyles";
import { DesktopOnly } from "./util/desktopOnly";

//region [[ Styles ]]
const ReferencesViewWrapper = styled(ScrollableContainer)({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  width: "100%",
  overflowY: "auto",
});

const GraphSelectionSummaryRow = styled(GraphSelectionSummary)({
  position: "static",
  boxShadow: "unset",
  padding: "10px",
  margin: "unset",
  width: "100%",
});

const CloseButtonContainer = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});

const StyledDesktopOnly = styled(DesktopOnly)({
  height: "auto",
});

//endregion [[ Styles ]]

//region [[ Props ]]
export interface ReferencesViewProps extends SupportFocusMutation {
  graphSelection: GraphDetailSelection;
  onClose?: () => any;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
export const ReferencesView = ({
  graphSelection,
  onClose,
}: ReferencesViewProps) => {
  return (
    <ReferencesViewWrapper>
      <CloseButtonContainer>
        {onClose && (
          <Button onClick={onClose} variant={"text"} color={"primary"}>
            Close
          </Button>
        )}
      </CloseButtonContainer>
      <StyledDesktopOnly>
        <GraphSelectionSummaryRow selection={graphSelection} />
      </StyledDesktopOnly>
      <GraphDetails onClose={() => null} {...graphSelection} />
    </ReferencesViewWrapper>
  );
};
